import { render, staticRenderFns } from "./SSOVIew.vue?vue&type=template&id=03a39856"
import script from "./SSOVIew.vue?vue&type=script&lang=js"
export * from "./SSOVIew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports